import React from 'react';
import {
  Paper,
  Typography
} from '@mui/material';
import { Inventory } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { EmptyStateProps } from './types';

export const EmptyState: React.FC<EmptyStateProps> = ({ hasQuery, searchQuery }) => {
  const { t } = useTranslation();

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 6,
        textAlign: 'center',
        bgcolor: 'background.paper',
        borderStyle: 'dashed',
        borderColor: 'primary.light',
      }}
    >
      <Inventory sx={{ fontSize: 52, color: 'grey.400', mb: 2 }} />
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {hasQuery ? t('products.noResults') : t('products.emptyTitle')}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {hasQuery
          ? t('products.noResultsHint')
          : t('products.emptyHint')
        }
      </Typography>
    </Paper>
  );
};
